var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{attrs:{"flat":""}},[_c('render-content',{attrs:{"id":"policies"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }